import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { H3 } from '../../Typography';
export var StyledLabel = styled(H3)(_templateObject(), function (props) {
  return "\n        margin-top: 0;\n        color: ".concat(props.theme.global.colors.doveGrayLight, ";\n        ").concat(props.disabled ? "color: ".concat(props.theme.global.colors.porcelainDarker, ";") : '', "\n    ");
});
export var StyledHelperContainer = styled.div(_templateObject2(), function (props) {
  return "\n        background-color: ".concat(props.theme.global.colors.primary, ";\n        border-radius: 50%;\n        display: inline-block;\n        margin-left: 5px;\n        position: relative;\n        height: 15px;\n        width: 15px;\n        vertical-align: text-top;\n        cursor: pointer;\n\n        & > svg {\n            color: ").concat(props.theme.global.colors.white, ";\n            font-size: 10px;\n            position: absolute;\n            top: 2px;\n            left: 5px;\n        }\n    ");
});